// @flow
import * as React from 'react';
import { Typography } from '@mui/material';

export const ClientInDncListNotification = () => {
  return (
    <Typography align={'center'} color={'#fff'} sx={{background: 'linear-gradient(90deg, rgba(234, 234, 234, 1) 0%, rgba(243, 112, 40, 1) 2%, rgba(243, 112, 40, 1) 98%, rgba(234, 234, 234, 1) 100%)', py: .5}} variant={'body2'}>
      This customer on DNC registry. Take extra care to make sure Customer Profile Name matches Voice Mail. Take caution.
    </Typography>
  );
};
